import { EmptyOrErrorPlate } from './EmptyOrErrorPlate';

export default EmptyOrErrorPlate;
